/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import { Message } from '../../../../phase2/survey/page/nps/Nps';
import NpsRadios from '../../../../phase2/survey/page/nps/children/NpsRadios';
import NpsGuide from '../../../../phase2/survey/page/nps/children/NpsGuide';
// embedded
import {
  StyledBox,
  StyledMessage,
  StyledMessageBox,
  StyledRadiosBox,
  StyledGuideDiv,
  StyledWrapper,
} from './style';

/**
 * 埋込み型 `Nps` component 作成します
 * @param {string} name radio へ付与する name 属性値
 * @param {Array<*>} optionValues radio 生成に使用する list
 * @param {string} message 上部表示 text
 * @param {function} onChange radio.onchange callback
 * @param {string} minScoreLabel radio 下 min 表示 text
 * @param {string} maxScoreLabel radio 下 max 表示 text
 * @param {?number} alreadyChecked checked `radio` index - generator で保存データ再現時にしようしまうs
 * @param {boolean} desktop - resize desktop flag
 * @param {boolean} disabled - radio disabled attribute
 * @return {*} React.node
 * @constructor
 */
const NpsEmbedded = ({
  name,
  optionValues,
  message,
  onChange,
  minScoreLabel,
  maxScoreLabel,
  alreadyChecked,
  desktop,
  disabled,
}) => {
  // console.log('NpsEmbedded - desktop', desktop);
  // embedded-type
  return (
    <StyledWrapper desktop={desktop}>
      <StyledBox className={'NpsEmbedded-StyledBox'}>
        <StyledMessageBox className={'NpsEmbedded-StyledMessageBox'}>
          <Message message={message} StyledComponent={StyledMessage} />
        </StyledMessageBox>
        <StyledRadiosBox>
          <NpsRadios
            name={name}
            optionValues={optionValues}
            // onChange={props.onChange ? props.onChange : onChange}
            onChange={onChange}
            alreadyChecked={alreadyChecked}
            disabled={disabled}
          />
        </StyledRadiosBox>
        <StyledGuideDiv>
          <NpsGuide txt0={minScoreLabel} txt1={maxScoreLabel} />
        </StyledGuideDiv>
      </StyledBox>
    </StyledWrapper>
  );
};

export default NpsEmbedded;



// WEBPACK FOOTER //
// ./src/embedded-type/survey/page/nps/NpsEmbedded.js